var map = {
	"./new_h2_default.json": [
		64920,
		4920
	],
	"./new_h2_default_eur.json": [
		71435,
		1435
	],
	"./new_h2_default_gbp.json": [
		89659,
		7089
	],
	"./new_h2_french.json": [
		62349,
		2349
	],
	"./new_h2_german.json": [
		85524,
		5524
	],
	"./new_h2_portuguese.json": [
		52272,
		2272
	],
	"./new_h2_reading.json": [
		54196,
		4196
	],
	"./new_h2_spanish.json": [
		18115,
		8115
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 69673;
module.exports = webpackAsyncContext;